module.exports = __webpack_public_path__ + "static/img/best-ecn-stp2023.b781d85.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/best-ecn-stp2023.svg
// module id = nTdM
// module chunks = 4